// Scroll to main ATC and trigger click when any [data-add-btn] is clicked
document.addEventListener('click', function (e) {
  const triggerBtn = e.target.closest('.template-product [data-add-btn]');
  if (!triggerBtn) return;

  e.preventDefault();

  const mainAtcBtn = document.querySelector('.product-form__buttons .product-form__submit');
  if (!mainAtcBtn) return;

  // Smooth scroll to main ATC
  mainAtcBtn.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });

  // Trigger click after scroll
  setTimeout(() => {
    mainAtcBtn.click();
  }, 600); // adjust timing if needed
});